<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="emRepairOrderDetail.pkid > 0 ? '编辑':'新建'"
        width="1000px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="emRepairOrderDetail"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <div>
          <div class="vm-separate">
            <el-form-item label="工单编号" prop="orderNo">
              <el-input v-model="emRepairOrderDetail.orderNo" :disabled="emRepairOrderDetail.pkid>0" readonly placeholder="选择">
                <el-button
                    slot="append"
                    :disabled="emRepairOrderDetail.pkid >10"
                    icon="el-icon-search"
                    @click="$refs.selectEmrepairOrder.open()"/>
              </el-input>
              <e-m-repair-order-select ref="selectEmrepairOrder" @select="selectEmrepairOrder"/>
            </el-form-item>
            <el-form-item label="修理人员">
              <el-input v-model="emRepairOrderDetail.repairMan" readonly placeholder="选择">
                <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="$refs.repairManSelect.open()"/>
              </el-input>
              <repair-man-select ref="repairManSelect" @select="repairManSelect"/>
            </el-form-item>
          </div>
          <div class="vm-separate">
            <el-form-item label="预估费用">
              <el-input v-model="emRepairOrderDetail.estimatedCost" placeholder="选择"/>
            </el-form-item>
            <el-form-item label="修理方法">
              <template>
                <el-radio-group v-model="emRepairOrderDetail.repairMethod">
                  <el-radio :label="10">内修</el-radio>
                  <el-radio :label="20">外修</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
          </div>
          <div class="vm-separate">
            <el-form-item label="开始时间">
              <el-date-picker
                  v-model="emRepairOrderDetail.beginTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="选择日期"/>
            </el-form-item>
            <el-form-item label="结束时间">
              <el-date-picker
                  v-model="emRepairOrderDetail.endTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="选择日期"/>
            </el-form-item>
          </div>
          <el-form-item label="维修内容">
            <el-input v-model="emRepairOrderDetail.repairContent" type="textarea" placeholder="请输入"/>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

  import constant from "../../../util/constant";
  import constants from "../../../util/constants";
  import RepairManSelect from "@/views/em/EMRepairOrder/RepairManSelect";
  import EMRepairOrderSelect from "@/views/em/EMRepairOrder/EMRepairOrderSelect";

  export default {
    name:"EMRepairOrderDetailEdit",
    components: {EMRepairOrderSelect, RepairManSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        constant,
        constants,
        value: "",
        title: "",
        unusableDesc: "",
        urgencyType: constant.toSelect(constant.urgencyType),
        faultDealMethod: constant.toSelect(constant.faultDealMethod),
        results: constant.toSelect(constant.result),
        reportOrderStatus: constant.toSelect(constant.reportOrderStatus),
        tableData: [],
        deleteIds: [],
        emRepairOrderDetail: {
          pkid: 0,
          orderNo: "",
          masterId: "",
          repairMethod: 10,
          beginTime: "",
          endTime: "",
          repairMan: "",
          estimatedCost: "",
          repairContent: "",
        },
        ruleValidate: {
          orderNo: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(id, val) {
        this.dialogVisible = true;
        this.emRepairOrderDetail.pkid = id;
        this.value = val;
        if (id > 0) {
          this.getData();
        } else {
          this.getNo();
        }
      },
      getData() {
        this.$http
          .get("basic", `emRepairOrderDetails/${this.emRepairOrderDetail.pkid}`)
          .then(resp => {
            this.emRepairOrderDetail = resp;
          });
      },
      getNo() {
        this.$http
          .get("basic", "emRepairOrderDetails")
          .then(resp => {
            console.log(resp);
          });
      },
      selectEmrepairOrder(row) {
        console.log(row);
        this.emRepairOrderDetail.masterId = row.pkid;
        this.emRepairOrderDetail.orderNo = row.no;
      },

      repairManSelect(row) {
        console.log(row);
        this.emRepairOrderDetail.repairMan = row.dealMan;
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            if(this.emRepairOrderDetail.estimatedCost==="" || this.emRepairOrderDetail.estimatedCost===null) {
              this.emRepairOrderDetail.estimatedCost = 0;
            }
            this.submitLoading = true;
            this.$http
              .save("basic", "emRepairOrderDetails", this.emRepairOrderDetail)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
